 document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto', // Allow slides to adjust based on container width
      spaceBetween: 10,
      loop: false, // Disable infinite loop
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      mousewheel: false, // Disable mousewheel control
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      touchEventsTarget: 'container',
      simulateTouch: true,
      grabCursor: true,
      touchRatio: 1,
      threshold: 10,
      touchAngle: 45,
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      preventInteractionOnTransition: true,
    });
  });
